import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import {Subject} from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardService} from "../services/card.service";
import {Card} from "../models/card";
import {CardLog} from "../models/cardLog";
import {CardLogService} from "../services/cardLog.service";
import {ResourceService} from "../services/resource.service";
import {Resource} from "../models/resource";
import {VirtualReceiptService} from "./service/virtualReceipt.servicee";
import {VirtualReceipts} from "./model/virtualReceipts";
import {VirtualReceipt} from "./model/virtualReceipt";

@Component({
    templateUrl: './virtualReceipt.component.html',
    styleUrls: ['./virtualReceipt.component.scss']
})
export class VirtualReceiptComponent implements OnDestroy, OnInit {
    id: string;
    user: User;
    card: Card;
    virtualReceipts: VirtualReceipt[];
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    logs: CardLog[];

    constructor(
        private virtualReceiptService: VirtualReceiptService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Open bills');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.virtualReceiptService.getAllPaged(0, 100)
            .pipe(first())
            .subscribe((virtualReceipts: VirtualReceipts) => {
                this.virtualReceipts = virtualReceipts.items;
            });
    }

    ngOnDestroy(): void {

    }
}
